import { createSlice } from '@reduxjs/toolkit';
import { Slices } from 'ducks/slices';
import { v4 as uuidv4 } from 'uuid';

export interface PreventPreemptionsListState {
  name: 'Yes' | 'No';
  value: boolean;
  uuid: string;
}

const initialState: PreventPreemptionsListState[] = [
  {
    name: 'Yes',
    value: true,
    uuid: uuidv4(),
  },
  {
    name: 'No',
    value: false,
    uuid: uuidv4(),
  },
];

const preventPreemptionsListSlice = createSlice({
  name: Slices.PREVENT_PREEMPTIONS_LIST,
  initialState,
  reducers: {
    setPreventPreemptionsList: (_, action) => {
      return action.payload;
    },
    clearPreventPreemptionsList: () => {
      return initialState;
    },
  },
});

export const { setPreventPreemptionsList, clearPreventPreemptionsList } = preventPreemptionsListSlice.actions;

export default preventPreemptionsListSlice.reducer;
